import React, { Component } from 'react'
import { render } from 'react-dom'

import { InlineMath, BlockMath } from 'react-katex';

import 'katex/dist/katex.min.css';

class TestKatexExamples extends Component {
  render() {
    return (
      <div>

        <h2>react + Katex 数式を打ち込む例</h2>

        <h3>Inline</h3>
        <p>
        　これはインラインで<InlineMath>\displaystyle \int_0^\infty x^2 dx</InlineMath>で数式を入れる例です。
        </p>

        <p>
        　これはインラインで<InlineMath>{`\\displaystyle \\int_0^\\infty x^2 dx = \\frac{1}{2}`}</InlineMath>で数式を入れる例です。
        </p>

        <p>
        　<InlineMath>{`\\displaystyle \\frac{w}{2}  `}</InlineMath>
        </p>

        <p>
        　今日はとても楽しい一日だった <InlineMath>{`\\displaystyle \\frac{34}{x} `}</InlineMath>今日はとても楽しい一日だった 今日はとても楽しい一日だった 今日はとても楽しい一日だった 今日はとても楽しい一日だった 今日はとても楽しい一日だった 今日はとても楽しい一日だった 
        </p>
        

        <h3>BlockLine</h3>
        <h4>複数行の例</h4>
        
        <BlockMath>{`

          \\begin{aligned} 
          x &= 1+1 \\\\ 
            &= 2 \\,\\,\\,\\, \\cdot\\cdot\\cdot \\,\\,\\,\\,  \\left(2\\right)
          \\end{aligned}

        `}</BlockMath>

        <h4>複数行の例</h4>
        <BlockMath>{`

          \\begin{aligned} 
            \\int_0^\\infty x^2 dx &= \\frac{1}{x + 1} \\\\
            &= \\frac{x^2 + 2}{x - 1}
          \\end{aligned}

        `}</BlockMath>

        <h4>複数行の例</h4>
        <BlockMath>{`

          \\begin{aligned} 
            P_{r} \\left(R,r_1, r_2, \\cdots , r_g \\right) &=\\frac{\\Gamma\\left(S \\right)}{\\displaystyle \\prod_{i=1}^{N} \\Gamma\\left(\\alpha_j \\right)} \\cdot \\frac{\\displaystyle \\prod_{i=1}^{N} \\Gamma\\left(r_j + \\alpha_j \\right)}{\\Gamma\\left(S+R \\right)} \\cdot \\frac{1}{\\displaystyle \\prod_{j=1}^{g} r_j!} \\cdot \\\\
            &= \\frac{x^2 + 2}{x - 1} \\\\
            &=\\sum_{j=i}^{g}r_j  \\,\\,\\,\\,\\cdot\\cdot\\cdot\\cdot\\,\\,\\,\\,\\left(2\\right) 

          \\end{aligned}
        `}</BlockMath>

        <table border="1" cellpadding="15" 
         style={{
            "text-align": "center",
            "width": "100%",
            "height": "150px",
            "padding": "15px",
        }}> 

          <tr>
            <th>名前</th>
            <th>確率密度関数</th>
            <th>確率変数</th>
            <th>params</th>
            <th><InlineMath>{`\\displaystyle E[x]`}</InlineMath></th>
            <th><InlineMath>{`\\displaystyle V[x]`}</InlineMath></th>
          </tr>
          <tr>
            <td>二項分布</td>
            <td><InlineMath>{`\\displaystyle \\binom{n}{k}p^k\\left(1-p\\right)^{n-k} `}</InlineMath></td>
            <td><InlineMath>{`\\displaystyle k`}</InlineMath></td>
            <td><InlineMath>{`\\displaystyle n,p`}</InlineMath></td>
            <td><InlineMath>{`\\displaystyle np`}</InlineMath></td>
            <td><InlineMath>{`\\displaystyle np(1-p)`}</InlineMath></td>
          </tr>
        </table>

      </div>
    )   
  }
}

export default TestKatexExamples;
